var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createStore } from 'vuex';
import http from '@/lib/http-common';
import { setLoading } from '@/lib/set-loading';
import axios from 'axios';
export default createStore({
    state: {
        stocks: [],
        fx: [],
        quote: [],
        forex: {},
        isLoading: false,
    },
    getters: {
        getStocks: function (state) {
            return state.stocks;
        },
        getFx: function (state) {
            return state.fx;
        },
        getQuote: function (state) {
            return state.quote;
        },
        getForex: function (state) {
            return state.forex;
        },
    },
    mutations: {
        setDefaultStocks: function (state) {
            state.stocks = [];
        },
        addStocks: function (state, data) {
            state.stocks.push(data);
        },
        addFx: function (state, data) {
            state.fx.push(data);
        },
        addQuote: function (state, data) {
            state.quote.push(data);
        },
        addForex: function (state, data) {
            state.forex = {
                data: data
            };
        },
        setLoading: function (state, isLoading) {
            state.isLoading = isLoading;
        },
    },
    actions: {
        fetchDataStocks: function (_a, _b) {
            var commit = _a.commit;
            var symbol = _b.symbol;
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            commit('setDefaultStocks');
                            return [4 /*yield*/, setLoading(function () { return __awaiter(_this, void 0, void 0, function () {
                                    var data, error_1;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                _a.trys.push([0, 2, , 3]);
                                                return [4 /*yield*/, http.get("profile/" + symbol)];
                                            case 1:
                                                data = (_a.sent()).data;
                                                commit('addStocks', data[0]);
                                                return [3 /*break*/, 3];
                                            case 2:
                                                error_1 = _a.sent();
                                                if (axios.isAxiosError(error_1)) {
                                                    return [2 /*return*/, error_1.message];
                                                }
                                                else {
                                                    console.error('fetchDataStocks -- unexpected error: ', error_1);
                                                }
                                                return [3 /*break*/, 3];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); }, commit, 'setLoading')];
                        case 1:
                            _c.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        fetchFx: function (_a) {
            var commit = _a.commit;
            return __awaiter(this, void 0, void 0, function () {
                var data, error_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, http.get('fx/EURUSD')];
                        case 1:
                            data = (_b.sent()).data;
                            commit('addFx', data);
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _b.sent();
                            if (axios.isAxiosError(error_2)) {
                                return [2 /*return*/, error_2.message];
                            }
                            else {
                                console.error('fetchFx -- unexpected error: ', error_2);
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        fetchQuote: function (_a) {
            var commit = _a.commit;
            return http.get('quote/BTCUSD')
                .then(function (response) {
                if (!response.data['Error Message']) {
                    commit('addQuote', response.data[0]);
                }
            });
        },
        fetchForex: function (_a) {
            var commit = _a.commit;
            return http.get('forex')
                .then(function (response) {
                if (!response.data['Error Message']) {
                    commit('addForex', response.data[0]);
                }
            });
        },
    },
});
